<template>
	<div class="w1200">
			<div class="association-brief-box">
				<div class="crumbs">
					<span><a href="#/">首页 ></a></span>
					<span>会员服务</span>
				</div>
				<div class="article-box w1000">
					<h2>北京建筑设施服务企业协会入会须知</h2>
					<p>一、凡承认《北京建筑设施服务企业协会章程》，履行会员义务的企业，可以申请加入本会。<br /> 二、各类企业入会申请经批准后成为准会员。按时交纳会费后，正式成为本会企业会员。
					</p>
					<h3>基本条件：</h3>
					<p>1.拥护本团体的章程；<br /> 2.有加入本团体的意愿； <br />3.在本团体的业务 (行业、学科)领域内具有一定的影响。</p>
					<h3>申报材料：<a href="Membership.docx" download="企业会员单位申请表">点击下载《企业会员单位申请表》</a></h3>
					<p>1.填写《企业会员单位申请表》一份，在表中相应位置签字、盖章；<br /> 2.加盖企业公章的企业营业执照副本复印件一份；企业法人身份证复印件一份以及近期一吋证件照二张；
						<br /> 3.纸质企业简介一份,并发送电子版至协会会员部邮箱 bbsca2016@163.com</p>
					<p>以上各类材料均用A4纸打印，一并递送至会员部。如需会员铭牌，另收制作成本费（理事及以上级别会员不收）。</p>
					<p>经走访考察,审议合格后，颁发证件和会员证（铭牌），正式成为北京建筑设施服务企业协会会员。成为会员后，企业需设立一名联络员，负责企业与协会联系。如企业有重大事宜、联系方式变更等情况应及时通知会员部。</p>
				    <div class="msg">北京建筑设施服务企业协会会员部</div>
				    <div class="msg">联系电话：010-8352 0973</div>
				    <div class="msg">地址：北京市丰台区西局东街首科大厦A座1215室</div>
				</div>
			</div>

		</div>

</template>

<script>
	import Vue from 'vue';
	export default {

		data() {
			return {}
		},
		methods: {

		},
		components: {}
	}
</script>

<style>

	@import "../assets/css/detail.css";
</style>


// WEBPACK FOOTER //
// src/components/MemberService.vue